import { Action } from 'redux'
import { ISettings } from '../../../models/Object'
import { UserSettingsActions } from '../../../reducers/userObject/actionNames'

export const requestDataForUserSettings = (): IRequestDataAction => ({
  type: UserSettingsActions.RequestDataForUserSettings,
})

export type IRequestDataAction = Action<UserSettingsActions.RequestDataForUserSettings>

export const dataForUserSettingsAccepted = (
  settings: ISettings,
): IUserSettingsAccepted => ({
  settings,
  type: UserSettingsActions.DataForUserSettingsAccepted,
})

export interface IUserSettingsAccepted
  extends Action<UserSettingsActions.DataForUserSettingsAccepted> {
  settings: ISettings
}

export const dataForUserSettingsRejected = (
  errMessage: string,
): IUserSettingsRejected => ({
  errMessage,
  type: UserSettingsActions.DataForUserSettingsRejected,
})

export interface IUserSettingsRejected
  extends Action<UserSettingsActions.DataForUserSettingsRejected> {
  errMessage: string
}
